import { render, staticRenderFns } from "./LiqTable.vue?vue&type=template&id=99979356&"
import script from "./LiqTable.vue?vue&type=script&lang=js&"
export * from "./LiqTable.vue?vue&type=script&lang=js&"
import style0 from "./LiqTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports